import script from "./CopyRight.vue?vue&type=script&lang=ts&setup=true"
export * from "./CopyRight.vue?vue&type=script&lang=ts&setup=true"

import "./CopyRight.vue?vue&type=style&index=0&id=7417c6ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7417c6ce"]])

export default __exports__